var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import addUrlDefaultProtocol from '../../utils/addUrlDefaultProtocol';
import ResponsiveImage from '@cvent/nucleus-image';
/**
 * The Image widget.
 */
var Image = React.memo(function Image(props) {
    var imgUrl = props.imgUrl, altText = props.altText, description = props.description, hyperlink = props.hyperlink, translate = props.translate, supportsWebp = props.supportsWebp, width = props.width, breakpoints = props.breakpoints, srcSet = props.srcSet, sizes = props.sizes, style = props.style;
    var onLoad = function (event) {
        event.persist();
        if (props.onLoad) {
            props.onLoad(event);
        }
    };
    function getImage(url) {
        if (!url) {
            return React.createElement("div", __assign({}, resolve(props, 'placeholder')));
        }
        return React.createElement(ResponsiveImage, __assign({}, props.onLoad ? {
            onLoad: onLoad
        } : {}, { src: url, width: width, alt: altText, sizes: sizes, srcSet: srcSet, breakpoints: breakpoints, supportsWebp: supportsWebp, style: __assign(__assign({}, style), { maxWidth: width }) }));
    }
    return React.createElement("div", __assign({}, resolveTestId(props), resolve(props, 'container')),
        React.createElement("div", __assign({}, resolve(props, 'image', !imgUrl && 'limitSize')),
            React.createElement("div", __assign({}, resolve(props, 'imageWrapper')), hyperlink ? React.createElement("a", { href: translate(addUrlDefaultProtocol(hyperlink)), target: "_blank" }, getImage(imgUrl)) : getImage(imgUrl)),
            description && React.createElement("div", __assign({}, resolve(props, 'imageText'), { dangerouslySetInnerHTML: {
                    __html: description
                } }))));
});
Image.propTypes = {
    imgUrl: PropTypes.string,
    altText: PropTypes.string,
    hyperlink: PropTypes.string,
    description: PropTypes.string,
    translate: PropTypes.func.isRequired,
    onLoad: PropTypes.func,
    supportsWebp: PropTypes.bool,
    width: PropTypes.number,
    breakpoints: PropTypes.arrayOf(PropTypes.number),
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    style: PropTypes.object
};
export default Image;
